import { render, staticRenderFns } from "./view-driver-details.vue?vue&type=template&id=111c5d9b&scoped=true&"
import script from "./view-driver-details.vue?vue&type=script&lang=js&"
export * from "./view-driver-details.vue?vue&type=script&lang=js&"
import style0 from "./view-driver-details.vue?vue&type=style&index=0&id=111c5d9b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111c5d9b",
  null
  
)

export default component.exports